import { render, staticRenderFns } from "./PersonMe.vue?vue&type=template&id=ab5037d6"
import script from "./PersonMe.vue?vue&type=script&lang=js"
export * from "./PersonMe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports